// local
import { TRENDS } from './constants.js';
// packages
import { get } from 'svelte/store';
import { createFeed } from './stores.js';

import {
  renderSvelteComponent,
  findSvelteComponentContainer,
} from './utils/render.js';
import { derived } from 'svelte/store';

// components
import BalanceOfPower from './components/BalanceOfPower.svelte';

async function main() {
  const trendsFeed = await createFeed(TRENDS);

  // find the container
  const element = findSvelteComponentContainer('#hp-house-embed');

  if (element) {
    // get the id
    // const elementId = element.id;
    // filter trends feed to get the ca u.s. house data
    let houseTrendsFeed = derived(trendsFeed, ($feed) => $feed.house);
    // render
    renderSvelteComponent(
      BalanceOfPower,
      /** @type {HTMLElement} */
      element,
      {
        feed: houseTrendsFeed,
      }
    );
  }
}

main().catch(console.error);
